export const TOPIC_COLLECTION_IDENTIFIER = "topic";
